import { AccountFeatureFlag } from '@/services/auth/feature-flags';
import type { RawAccount } from '@/services/auth/types';
import { isEligibleForEssentialsOnboarding, isEligibleForOnboarding } from './completion';
import { ONBOARDING_PATHS } from './paths';

/** Just the raw-payload fields the selector reads; a full `RawAccount` satisfies it. */
export type PostSignupAccount = Pick<
  RawAccount,
  'feature_flags' | 'account_state' | 'plan_slug' | 'signup_profile' | 'public_settings'
>;

/**
 * Where signup sends the new account once its workspace is provisioned. Takes
 * the raw payload because this runs before the auth stores are populated, so
 * `useAuth()` and the hooks built on it would throw.
 */
export function selectPostSignupDestination(account: PostSignupAccount): string {
  const eligibility = {
    isFlagEnabled: account.feature_flags?.[AccountFeatureFlag.EssentialsOnboarding] === true,
    useCases: account.signup_profile?.messaging_use_cases ?? [],
    account,
  };

  if (!isEligibleForOnboarding(eligibility)) {
    return '/';
  }
  if (account.public_settings?.ai_enabled === true) {
    return ONBOARDING_PATHS.wizard;
  }
  // No wizard without AI: only the checklist cohort has a static question.
  return isEligibleForEssentialsOnboarding(eligibility) ? ONBOARDING_PATHS.getStarted : '/';
}
